import { Form } from 'react-bootstrap';
import React, { FC } from 'react';
import clsx from 'clsx';
import { DivTitle, FormCheck } from './styles';

interface Props {
  name: string;
  propertyValue: string;
  propertyLabel: string;
  value: string;
  options: Record<string, string>[];
  onChange?: (value: string) => void;
  title?: string;
  hasInnerBlock?: boolean;
  disabled?: boolean;
}

const Index: FC<Props> = ({
  name,
  propertyValue,
  propertyLabel,
  value,
  options = [],
  onChange = null,
  title = '',
  hasInnerBlock = false,
  disabled = false
}) => (
  <Form.Group>
    {title && <DivTitle>{title}</DivTitle>}
    {options.map((radioItem) => (
      <FormCheck
        id={`${name}-${radioItem[propertyValue]}`}
        key={radioItem[propertyValue]}
        type="radio"
        label={radioItem[propertyLabel]}
        disabled={disabled}
        name={radioItem}
        onClick={() => onChange(radioItem[propertyValue])}
        className={clsx(
          { ['active']: radioItem[propertyValue] === value },
          { ['has-inner-block']: hasInnerBlock },
          { ['disabled']: disabled }
        )}
      />
    ))}
  </Form.Group>
);

export default Index;
